import React, { useEffect } from 'react';
import PatientHeader from './PatientHeader';
import managementStyles from '../ManagementPages.module.css';
import { useNavigate } from 'react-router-dom';
import { LeftArrowIcon } from '../../components/icons/Icons';
import PatientDetailBody from './PatientDetailBody';
import { setPatientPrograms, resetPatientState, setPatientDetails, setPatientOrgHierarchy, setFormField, setAlerts } from '../../slicers/PatientSlice';
import useAxios from '../../services/AxiosConfig';
import { useDispatch, useSelector } from 'react-redux';
import { resetNotesState } from './Slices/PatientDetailNotesSlice';
import { resetPatientDetailsState, setMenuItem } from './Slices/PatientDetailSlice';
import { useParams } from 'react-router-dom';
import { setNotifications } from '../../slicers/NotificationSlice';
import {
  fetchPatientEnrollments,
  fetchPatientAppointments,
  getQuestionnaires,
  formatAppointments,
} from './patientDetailUtils';

const PatientDetail = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const axiosConfig = useSelector((state) => state.axiosConfig);
  const axios = useAxios(axiosConfig.envURL);
  const userAccountId = useSelector((state) => state.userInfo.id);
  const patientInfo = useSelector((state) => state.patient);
  const patientId = patientInfo.id;
  const sidebarSlicer = useSelector((state) => state.sidebar);

  const { tab } = useParams();

  useEffect(() => {
    if (tab) {
      dispatch(setMenuItem(tab));
    } else {
      dispatch(setMenuItem("Vitals"));
    }
  }, [])

  const onBackHandler = () => {
    dispatch(resetPatientState());
    dispatch(resetNotesState());
    dispatch(resetPatientDetailsState());
    navigate(-1);
  };

  useEffect(() => {
    const fetchData = async () => {
      let careTeam = [];
      // get patient info
      try {
        const patientResponse = await axios.get(`user/${patientId}`)
        if (patientResponse.data.data) {
          dispatch(setPatientDetails(patientResponse.data.data));
          careTeam = patientResponse.data.data.careTeam || [];
          dispatch(setFormField({ key: "careTeam", value: careTeam }));
        } else {
          console.error('Error fetching patient info');
        }
      } catch (err) {
        console.log(err);
      }

      // get logged in user's settings for patient
      try {
        const patientResponse = await axios.get(`/careTeam/authorization/${userAccountId}/${patientId}`)
        if (patientResponse.data.data) {
          dispatch(setFormField({ key: "userSettingsForPatient", value: patientResponse.data.data[0] }));
        } else {
          console.error('Error fetching patient info');
        }
      } catch (err) {
        console.log(err);
      }

      // get alerts
      try {
        const alertResponse = await axios.get(`alerts/${patientId}`);
        if (Array.isArray(alertResponse.data.data)) {
          dispatch(setAlerts(alertResponse.data.data));
        } else {
          console.error('Error fetching alerts for patient');
        }
      } catch (err) {
        console.log(err);
      }

      // get patient enrollments + questionnaire responses
      const enrollmentData = await fetchPatientEnrollments(axios, patientId);
      if (enrollmentData) {
        const questionnaireIds = await getQuestionnaires(axios, enrollmentData);
        dispatch(setFormField({ key: "questionnaireIds", value: questionnaireIds }));
        dispatch(setPatientPrograms(enrollmentData));
      }

      // get groups
      axios.get(`list/groups/${patientId}`)
        .then((responseData) => {
          if (Array.isArray(responseData.data.data)) {
            dispatch(setPatientOrgHierarchy(responseData.data.data));
          } else {
            console.error("Can't fetch patient groups");
          }
        })
        .catch((err) => {
          console.log(err);
        });
      // get appointments
      const appointmentData = await fetchPatientAppointments(axios, patientId);
      if (appointmentData) {
        const formattedAppointments = formatAppointments(appointmentData, careTeam);
        dispatch(setFormField({ key: "appointments", value: formattedAppointments }));
      }

      axios.get(`staffTasks/listByPatientId/${userAccountId}/${patientId}`)
        .then((responseData) => {
          if (Array.isArray(responseData.data.data)) {
            const formattedTasks = responseData.data.data.map(task => {
              task.type = "Task";
              return task;
            });
            dispatch(setFormField({ key: "tasksByPatient", value: formattedTasks }));
          } else {
            console.error("Can't fetch listByPatientId task");
          }
        })
        .catch((err) => {
          console.log(err);
        });

      axios.get(`/notifications/list/${userAccountId}`)
        .then((responseData) => {
          if (Array.isArray(responseData.data.data)) {
            const filteredNotifications = responseData.data.data.filter((item) =>
              (item.linkedAccountId && parseInt(item.linkedAccountId, 10) === patientId)
            ).map(notif => {
              notif.type = "Bell";
              return notif;
            });
            dispatch(setFormField({ key: "patientNotifications", value: filteredNotifications }));
            dispatch(setNotifications(responseData.data.data));
          } else {
            console.error('Error fetching notifications:');
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };
    if (patientInfo.id) {
      fetchData();
    }
  }, []);

  return (
    <div className={managementStyles.MainContent}>
      <div className={`${managementStyles.ReturnToOverviewManagement} align-items-start`} style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }} onClick={onBackHandler}>
          <LeftArrowIcon style={{ cursor: 'pointer', marginRight: '8px' }} />
          <span style={{ cursor: 'pointer', paddingLeft: "5px" }}>{`Back to ${sidebarSlicer.selectedMenuItem}`}</span>
        </div>
      </div>
      <PatientHeader />
      <PatientDetailBody />
    </div>
  );
}

export default PatientDetail;